const ZONE_COLOR_OPACITY_HEX = 80; // Hex value for 50

export {ZONE_COLOR_OPACITY_HEX};
